var AUTH_STORAGE_KEY = "ai_creator_auth";

export function readAuthState() {
  var raw = localStorage.getItem(AUTH_STORAGE_KEY);

  if (!raw) {
    return createEmptyAuthState();
  }

  try {
    var parsed = JSON.parse(raw);
    return normalizeAuthState(parsed);
  } catch (error) {
    clearAuthState();
    return createEmptyAuthState();
  }
}

export function saveAuthState(payload) {
  var nextState = normalizeAuthState(payload);
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(nextState));
  return nextState;
}

export function clearAuthState() {
  localStorage.removeItem(AUTH_STORAGE_KEY);
}

export function createEmptyAuthState() {
  return {
    accessToken: null,
    tokenType: null,
    expiresIn: null,
    user: null
  };
}

function normalizeAuthState(payload) {
  var source = payload || {};

  return {
    accessToken: source.accessToken || null,
    tokenType: source.tokenType || null,
    expiresIn: source.expiresIn || null,
    user: source.user || null
  };
}
